export default __webpack_public_path__ + "static/media/lv.458e99b7.svg";